import { Input } from 'antd';
import './InputComponent.scss';
import { Divider } from 'antd';
import { useCallback, useRef } from 'react';
import {
  evaluateExpression,
  getInputType,
  isValidExpression,
} from '../../../utils/string/inputExpression';

const InputComponent = ({ ...props }) => {
  const debounceTimerRef = useRef(null);

  /**
   * Evaluate expression if valid
   */
  const evaluateIfExpression = useCallback(value => {
    if (!value) return value;

    const type = getInputType(value);
    return type === 'expression' && isValidExpression(value)
      ? evaluateExpression(value)
      : value;
  }, []);

  /**
   * Filter input - allow only numbers, operators, parentheses, decimals
   */
  const handleChange = useCallback(
    e => {
      // Call onChange immediately (without evaluation)
      props.onChange?.(e);

      // Setup debounced evaluation and validation
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      debounceTimerRef.current = setTimeout(() => {
        const inputValue = e.target?.value;
        const evaluatedValue = evaluateIfExpression(inputValue);

        // If expression was evaluated, update the input and trigger onChange
        if (evaluatedValue !== inputValue) {
          e.target.value = evaluatedValue;
          props.onChange?.({
            ...e,
            target: { ...e.target, value: evaluatedValue },
          });
        }
      }, 500);
    },
    [props?.onChange, evaluateIfExpression]
  );

  /**
   * Cleanup debounce timer on unmount
   */
  const handleCleanup = useCallback(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
  }, []);

  return (
    <Input
      size="default"
      onWheel={e => e.currentTarget.blur()}
      {...props}
      // onChange={handleChange}
      onKeyDown={e => {
        if (props.onKeyDown) {
          props.onKeyDown(e);
        }
        if (e.key === 'Enter') {
          e.preventDefault();
          handleChange(e);
        }
      }}
      onUnmount={handleCleanup}
      style={{
        appearance: 'textfield',
        ...props?.style,
      }}
      addonAfter={
        props.addonAfter ? (
          <>
            <div className="flex ps-0 pe-8 items-center">
              <Divider
                type="vertical"
                className={
                  props?.size === 'small' ? 'h-14 m-0 me-4' : 'h-16 m-0 me-8'
                }
                style={{ backgroundColor: '#CFD1D2' }}
              />
              {props.addonAfter}
            </div>
          </>
        ) : null
      }
      addonBefore={
        props.addonBefore ? (
          <>
            <div className="flex pe-0 ps-8 items-center">
              {props.addonBefore}
              <Divider
                type="vertical"
                className={
                  '!p-0' + props?.size === 'small'
                    ? 'h-14 m-0 mx-4'
                    : 'h-18 m-0 mx-8'
                }
                style={{ backgroundColor: '#CFD1D2' }}
              />
            </div>
          </>
        ) : null
      }
    />
  );
};

export default InputComponent;
